import { Locale } from "@core/services";

export class TranslateDetail implements Locale{
    lang: string;
    data: Object;

}
